import { useState } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import './FilterDropdown.scss';

type FilterDropdownProps = {
  name: string;
  label: string;
  options: string[];
  value: string[];
  onChange: (values: string[]) => void;
};

const FilterDropdown = ({ name, label, options, value, onChange }: FilterDropdownProps) => {
  const [open, setOpen] = useState(false);
  const selectionLabel = value.length > 4 ? `${value.length} selected` : value.join(', ') || 'All';

  return (
    <fieldset className="accounts-filterDropdown mb-3" name={name}>
      <legend>{label}</legend>
      <Dropdown show={open} onToggle={setOpen} autoClose="outside">
        <Dropdown.Toggle
          id={`accounts-filter-${name}`}
          variant=""
          className="Button Button--whiteBlack"
          aria-label={label}
          aria-describedby={`accounts-filter-${name}-selection`}
          aria-controls={`accounts-filter-${name}-options`}
        >
          <span id={`accounts-filter-${name}-selection`} className="accounts-filterDropdown-value">
            {selectionLabel}
          </span>
        </Dropdown.Toggle>
        <Dropdown.Menu renderOnMount hidden={!open} id={`accounts-filter-${name}-options`}>
          <label className="accounts-filterDropdown-option">
            <input type="checkbox" value="" checked={!value.length} onChange={() => onChange([])} />
            <span>All</span>
          </label>
          {options.map((option) => (
            <label className="accounts-filterDropdown-option" key={option}>
              <input
                type="checkbox"
                value={option}
                checked={value.includes(option)}
                onChange={(event) =>
                  onChange(event.target.checked ? [...value, option] : value.filter((item) => item !== option))
                }
              />
              <span>{option}</span>
            </label>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </fieldset>
  );
};

export default FilterDropdown;
